import { FC, useEffect, useState } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui';

import { useModalStore } from '@/store/use-modal-store';
import Loader from '@/components/ui/loader';

export const QrCodeModal: FC = () => {
  const { isQrCodeModalOpen, handleQrCodeModalOpen } = useModalStore();
  const [isQrCodeView, setIsQrCodeView] = useState<boolean>(false);

  const { qrCodeUrl } = useModalStore();

  return (
    <Dialog open={isQrCodeModalOpen} onOpenChange={handleQrCodeModalOpen}>
      <DialogContent className="gap-0 border border-border bg-background p-0 sm:max-w-lg sm:rounded-none">
        <DialogHeader className="px-5 pt-6">
          <DialogTitle className="text-xl text-foreground">
            Link Mobile Device
          </DialogTitle>
        </DialogHeader>
        <div className="flex flex-col items-center px-5 pb-10 pt-6 text-center">
          <Loader className="w-20 pt-5" />
          <p className="text-lg">
            Access {window.location.origin} on your mobile device and select
            Desktop wallet to scan the code.
          </p>
          {isQrCodeView && (
            <div className="mt-5 bg-white p-2">
              <QRCodeCanvas value={qrCodeUrl} size={256} />
            </div>
          )}
          <p className="mt-10 rounded-xl border border-primary bg-primary bg-opacity-10 p-2">
            Deposits and withdrawals are disabled in this mode. For security
            reasons, never share this QR code or any screenshots with anyone
            else. If you suspect a code has been compromised, generate a new one
            to invalidate previously-generated codes.
          </p>
        </div>
        <DialogFooter>
          <Button
            type="submit"
            className="h-14 w-full rounded-none font-mono text-lg font-normal tracking-wider"
            onClick={() => setIsQrCodeView((prev) => !prev)}
          >
            CLICK TO {isQrCodeView ? 'HIDE' : 'REVEAL'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
